var map = {
	"./africa/flg.vue": [
		"ZKIG",
		27
	],
	"./black/flg.vue": [
		"k4yq",
		26
	],
	"./club-soft/flg.vue": [
		"NU3l",
		34
	],
	"./deep-blue/flg.vue": [
		"2b1Q",
		33
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "VK8L";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/games/flg lazy ^\.\/.*\/flg\.vue$
// module id = VK8L
// module chunks = 37